import React from 'react'

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <g>
                <mask
                    id="mask0_5569_132756"
                    style={{ maskType: 'alpha' }}
                    width="24"
                    height="24"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                >
                    <path fill="#D9D9D9" d="M0 0H24V24H0z"></path>
                </mask>
                <g mask="url(#mask0_5569_132756)">
                    <path
                        fill="#1A1A1A"
                        fillRule="evenodd"
                        d="M12 21.5a9.5 9.5 0 100-19 9.5 9.5 0 000 19zm2.943-10.44l.338-1.154h-1.41a3.024 3.024 0 00-.32-.91 2.436 2.436 0 00-.232-.355l1.624.013.338-1.154H8.838L8.5 8.614h1.372l.775.006c.636.033 1.117.205 1.442.516.221.209.375.466.462.77H8.838L8.5 11.06h4.086a1.581 1.581 0 01-.213.527c-.176.268-.43.47-.76.606-.332.133-.733.2-1.204.2H8.6l.02.834 3.64 4.455h1.55v-.08l-3.36-4.116h.03c.828 0 1.495-.134 1.998-.403.507-.268.875-.623 1.104-1.064.157-.3.261-.62.312-.96h1.05z"
                        clipRule="evenodd"
                    ></path>
                </g>
            </g>
        </svg>
    )
}

export default Icon
